import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-featured-content-dep.css.lit';

import '../../se-container/se-container';
import '../../se-heading/se-heading';
import '../../se-link/se-link';
import '../../se-button/se-button';

export type SeContentFeatures = {
  text: string;
  url: string;
  type: string;
  date?: string;
};

/**
 * THIS COMPONENT IS DEPRECATED
 * The SeFeatureAlert component
 * @element se-featured-content-dep
 * @slot cta - slotted cta link
 */
@customElement('se-featured-content-dep')
export class SeFeaturedContentDep extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String })
  heading: string;

  @property({ type: String })
  description: string;

  @property({ type: String })
  cta: string;

  @property({ type: Array })
  alerts: SeContentFeatures[];

  @property({ type: String, attribute: 'cta-text' })
  ctaText: string;

  @property({ type: String, attribute: 'cta-url' })
  ctaUrl: string;

  render(): TemplateResult {
    return html`<section class="se-featured-content-dep">
      <se-container>
        <div class="se-featured-content-dep--content-wrapper">
          <div class="se-featured-content-dep--content">
            <se-heading level="h3" level-size="h1" font="rift"
              >${this.heading}</se-heading
            >
            <p>${this.description}</p>
            ${this.ctaTemplate()}
          </div>
        </div>
        <div class="se-featured-content-dep--alerts-wrapper">
          <ul class="se-featured-content-dep--alerts">
            ${this.renderAlerts()}
          </ul>
        </div>
      </se-container>
    </section>`;
  }

  renderAlerts() {
    return this.alerts.map(alert => {
      return html`<li
        class="se-featured-content-dep--alert"
        @click=${this.passClick}
      >
        <span class="se-featured-content-dep--alert-type"
          >${alert.type.toUpperCase()}</span
        >
        <a class="se-featured-content-dep--alert-link" href=${alert.url}
          >${alert.text}</a
        >
        ${alert.date
          ? html`<span class="se-featured-content-dep--alert-date"
              >${alert.date}</span
            >`
          : null}
      </li> `;
    });
  }

  ctaTemplate() {
    if (this.ctaUrl) {
      return html`
        <se-button
          button-url=${this.ctaUrl}
          button-target="_blank"
          variant="primary"
          button-label="${this.ctaText}"
          size="medium"
        >
          <outline-icon
            slot="right"
            size="1em"
            name="arrow-right"
            library="system"
            color="brand-secondary-1"
          ></outline-icon>
          ${this.ctaText}
        </se-button>
      `;
    } else {
      return null;
    }
  }

  passClick(e: Event) {
    const clickedLink = e.currentTarget as HTMLElement;

    const link = [...clickedLink.children].filter(
      el => el.nodeName === 'A'
    )[0] as HTMLAnchorElement;
    link.click();
  }
}
